import { render, staticRenderFns } from "./ImsTemplateManagement.vue?vue&type=template&id=1b352c6b&"
import script from "./ImsTemplateManagement.vue?vue&type=script&lang=js&"
export * from "./ImsTemplateManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports